import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const ArrowDownSvg = ({ fill = '#001965' }: { fill: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M4 17H16" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 3L10 13" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 9L10 13L6 9" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const ArrowDownDown = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={() => <ArrowDownSvg fill={props.fill || 'currentColor'} />} {...props} />
);

export default ArrowDownDown;
